if (!customElements.get('header-brand-tabs')) {
  class HeaderBrandTabs extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', this.handleClick.bind(this));
    }

    handleClick(evt) {
      const tab = evt.target.closest('.brand-tabs__tab');
      if (tab) {
        this.switchTab(tab.dataset.tab);
        return;
      }
      const sortBtn = evt.target.closest('.js-sort-toggle');
      if (sortBtn) {
        this.toggleSort(sortBtn);
      }
    }

    switchTab(handle) {
      this.querySelectorAll('.brand-tabs__tab').forEach((t) => {
        const active = t.dataset.tab === handle;
        t.classList.toggle('is-active', active);
        t.setAttribute('aria-selected', String(active));
      });
      this.querySelectorAll('.brand-tabs__panel').forEach((p) => {
        p.classList.toggle('is-active', p.dataset.tab === handle);
      });
    }

    toggleSort(btn) {
      const tabPanel = btn.closest('.brand-tabs__panel');
      const list = tabPanel.querySelector('.js-alpha-list');
      const isAsc = btn.dataset.dir === 'asc';
      btn.dataset.dir = isAsc ? 'desc' : 'asc';
      btn.textContent = isAsc ? 'Sort: Z–A' : 'Sort: A–Z';
      const groups = Array.from(list.querySelectorAll('.brand-tabs__alpha-group'));
      groups.reverse().forEach((g) => list.appendChild(g));
    }
  }

  customElements.define('header-brand-tabs', HeaderBrandTabs);
}
